import { toggleMenu, closeMenu } from '../components/menu.js';
import { toggleDarkMode, getSessionId } from '../index.js';

function addMenuEventListeners(socket) {
    // Exit Room
    const exitRoomBtn = document.getElementById('exit-room-button');
    exitRoomBtn.addEventListener('click', () => {
        socket.emit('exitRoom');
    });

    // Change player/spectator
    const spectatePlayButton = document.getElementById('spectate-play-button');
    spectatePlayButton.addEventListener('click', () => {
        socket.emit('switchPlayerType');
    });

    // Dark Mode Toggle
    const darkModeToggle = document.getElementById('dark-mode-toggle');
    darkModeToggle.addEventListener('click', () => {
        toggleDarkMode();
    });
}

function addFormEventListeners(socket) {
    // Create a room as player
    const createRoomBtnPlayer = document.getElementById('create-room-btn-player');
    createRoomBtnPlayer.addEventListener('click', () => {
        const playerName = document.getElementById('player-name-create').value;
        const roomName = document.getElementById('room-name-create').value;
        const clientCardSet = document.getElementById('card-set-create').value;
        // Set the Room name in local storage
        localStorage.setItem('roomName', roomName);
        // Note: sessionId not needed for createRoom as server generates new one
        socket.emit('createRoom', { roomName, playerName, isPlayer: true, clientCardSet });
    });

// Create a room as spectator
    const createRoomBtnSpectator = document.getElementById('create-room-btn-spectator');
    createRoomBtnSpectator.addEventListener('click', () => {
        const playerName = document.getElementById('player-name-create').value;
        const roomName = document.getElementById('room-name-create').value;
        const clientCardSet = document.getElementById('card-set-create').value;
        // Note: sessionId not needed for createRoom as server generates new one
        socket.emit('createRoom', { roomName, playerName, isPlayer: false, clientCardSet });
    });

// Join a room as player
    const joinRoomBtnPlayer = document.getElementById('join-room-btn-player');
    joinRoomBtnPlayer.addEventListener('click', () => {
        const roomId = document.getElementById('room-code-input').value.toUpperCase();
        const playerName = document.getElementById('player-name-join').value;
        const sessionId = getSessionId(roomId);
        socket.emit('joinRoom', { roomId, playerName, isPlayer: true, sessionId });
    });

// Join a room as spectator
    const joinRoomBtnSpectator = document.getElementById('join-room-btn-spectator');
    joinRoomBtnSpectator.addEventListener('click', () => {
        const roomId = document.getElementById('room-code-input').value.toUpperCase();
        const playerName = document.getElementById('player-name-join').value;
        const sessionId = getSessionId(roomId);
        socket.emit('joinRoom', { roomId, playerName, isPlayer: false, sessionId });
    });


// Join a room as player
    const joinRoomBtnPlayerJoiningForm = document.getElementById('join-pre-filled-join-room-btn-player');
    joinRoomBtnPlayerJoiningForm.addEventListener('click', () => {
        //Get whether we have a room id in the URL to join
        const urlParams = new URLSearchParams(window.location.search);
        const roomId = urlParams.get('room');
        const playerName = document.getElementById('join-pre-filled-player-name-join').value;
        if (roomId) {
            const sessionId = getSessionId(roomId);
            socket.emit('joinRoom', {roomId, playerName, isPlayer: true, sessionId});
        }
    });

// Join a room as spectator
    const joinRoomBtnSpectatorJoiningForm = document.getElementById('join-pre-filled-join-room-btn-spectator');
    joinRoomBtnSpectatorJoiningForm.addEventListener('click', () => {
        //Get whether we have a room id in the URL to join
        const urlParams = new URLSearchParams(window.location.search);
        const roomId = urlParams.get('room');
        const playerName = document.getElementById('join-pre-filled-player-name-join').value;
        if (roomId) {
            const sessionId = getSessionId(roomId);
            socket.emit('joinRoom', {roomId, playerName, isPlayer: false, sessionId});
        }
    });
}

export { addMenuEventListeners, addFormEventListeners };